<template>
    <!-- 集中式式退房详情 -->
    <div id="jzsReturnDetail">
        <!-- 详情 -->
        <div class="content nowarp" v-if="type == 0">
            <div class="inlineB">
                <p class="colorC l">退房类型</p>
                <p class="l">{{pQuitTypeList[jzsReturnDetail.quitType-1]}}</p>
            </div>
            <div class="inlineB">
                <p class="colorC l">退房日期</p>
                <p class="l">{{jzsReturnDetail.quitDate?jzsReturnDetail.quitDate.slice(0,10):''}}</p>
            </div>
            <div class="inlineB">
                <p class="colorC l">当前状态</p>
                <p class="l">{{pReturntStatusList[jzsReturnDetail.status-1]}}</p>
            </div>
        </div>
        <van-tabs v-model="active" class="tabs" v-if="type == 0">
            <van-tab title="基本信息" style="margin-top:0.2rem">
                <van-cell title="编码" :value="jzsReturnDetail.number" />
                <van-cell title="支付方式" :value="payTypeList[jzsReturnDetail.payType-1]" />
                <van-cell title="收款人姓名" :value="jzsReturnDetail.accountName" />
                <van-cell title="收款账号" :value="jzsReturnDetail.bankAccount" />
                <van-cell v-if="jzsReturnDetail.payType == 3" title="开户行" :value="jzsReturnDetail.bankName" />
                <van-cell v-if="jzsReturnDetail.payType == 3" title="支行名称" :value="jzsReturnDetail.bankBranchName" />
                <van-cell title="业主姓名" :value="jzsReturnDetail.propertyName" />
                <van-cell title="业主电话" class="space_bet">
                         <template #right-icon>
                        <a  class="tel" :href="'tel:'+jzsReturnDetail.propertyPhone">
                        <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
                        拨打
                        </a>
                        
                    </template>
                </van-cell>
                <van-cell title="证件号码"  :value="'【'+idTypeList[jzsReturnDetail.idType-1]+'】'+jzsReturnDetail.idNo" />
                <van-cell title="地址" :value="jzsReturnDetail.roomNo? jzsReturnDetail.houseAddress + jzsReturnDetail.roomNo:jzsReturnDetail.houseAddress" />
                <van-cell title="合约编码" :value="jzsReturnDetail.contractNumber" />
                <van-cell title="交房日期" :value="jzsReturnDetail.makeDate?jzsReturnDetail.makeDate.slice(0,10):''" />
                <van-cell title="生效日期" :value="jzsReturnDetail.activeDate?jzsReturnDetail.activeDate.slice(0,10):''" />
                <van-cell title="保底出租日期" :value="jzsReturnDetail.guaranteedDate?jzsReturnDetail.guaranteedDate.slice(0,10):''" />
                <van-cell title="开始日期" :value="jzsReturnDetail.startDate?jzsReturnDetail.startDate.slice(0,10):''" />
                <van-cell title="租期" :value="jzsReturnDetail.leaseMonth?jzsReturnDetail.leaseMonth+'月':''+jzsReturnDetail.leaseDay?jzsReturnDetail.leaseDay+'天':''" />
                <van-cell title="结束日期" :value="jzsReturnDetail.endDate?jzsReturnDetail.endDate.slice(0,10):''" />
                <van-cell title="支付方式" :value="jzsReturnDetail.payMonth == '999'?'全额付':'付'+jzsReturnDetail.payMonth+'押'+jzsReturnDetail.depositMonth" />
                <!-- <van-cell title="租金" :value="jzsReturnDetail.rental" /> -->
                <van-cell title="押金" :value="jzsReturnDetail.deposit" />
                <!-- <van-cell title="定金" :value="jzsReturnDetail.amount" /> -->
                <!-- <van-cell title="水电燃预交费" :value="jzsReturnDetail.advanceFee" /> -->
                <!-- <van-cell title="服务费" :value="jzsReturnDetail.serviceFee" /> -->
                <!-- <van-cell title="物业费" :value="jzsReturnDetail.condoFee" /> -->
                <van-cell title="创建人" :value="jzsReturnDetail.creator" />
                <van-cell title="创建日期" :value="jzsReturnDetail.createDate" />
            </van-tab>
            <van-tab title="已签房源" class="assets" style="margin-top:0.2rem">
                <div v-for="item in jzsReturnDetail.houseBuilding" :key="item.id">
                    <div v-for="(item1,index1) in item.houseBuildingItems" :key="index1">
                        <div class="title" v-if="item1.show">
                            <i class="iconfont iconbookmark"></i>
                            {{item.buildingNo+buildingTypeList[item.buildingType-1]+item1.level+"层"}}&ensp;
                        </div>
                        <div class="assetsBody" v-if="item1.show">
                            <div v-for="(item2,index2) in item1.roomInfo" :key="index2" :style="item2.isSign && jzsReturnDetail.contractId == item2.communityContractId?'':'display:none'">{{item2.number}}（{{item2.houseTypeName}}）</div>
                        </div>
                    </div>
                </div>
                <van-empty v-if="!jzsReturnDetail.houseBuilding.length" description="暂无数据" />
            </van-tab>
            <van-tab title="水电燃信息" style="margin-top:0.2rem">
                <div v-if="jzsReturnDetail.images.electricMax">
                    <div class="imgBody imgBody1">
                        <div class="imgCard">
                            <div class="text">电峰</div>
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsReturnDetail.images.electricMax]">
                                <van-image width="3rem" height="3rem" :src="jzsReturnDetail.images.electricMax" />
                            </div>
                            <div class="text">{{jzsReturnDetail.electricMax}}</div>
                        </div>
                        <div class="imgCard">
                            <div class="text">电谷</div>
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsReturnDetail.images.electricMin]">
                                <van-image width="3rem" height="3rem" :src="jzsReturnDetail.images.electricMin" />
                            </div>
                            <div class="text">{{jzsReturnDetail.electricMin}}</div>
                        </div>
                        <div class="imgCard">
                            <div class="text">电总</div>
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsReturnDetail.images.electricTotal]">
                                <van-image width="3rem" height="3rem" :src="jzsReturnDetail.images.electricTotal" />
                            </div>
                            <div class="text">{{jzsReturnDetail.electricTotal}}</div>
                        </div>
                    </div>
                </div>
                <div v-if="jzsReturnDetail.images.electricMax">
                    <div class="imgBody">
                        <div class="imgCard">
                            <div class="text">水</div>
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsReturnDetail.images.water]">
                                <van-image width="3rem" height="3rem" :src="jzsReturnDetail.images.water" />
                            </div>
                            <div class="text">{{jzsReturnDetail.water}}</div>
                        </div>
                    </div>
                    <div class="imgBody">
                        <div class="imgCard">
                            <div class="text">燃气</div>
                            <div class="img" @click="imgShow=true;imgIndex = 0;images=[jzsReturnDetail.images.gas]">
                                <van-image width="3rem" height="3rem" :src="jzsReturnDetail.images.gas" />
                            </div>
                            <div class="text">{{jzsReturnDetail.gas}}</div>
                        </div>
                    </div>
                </div>
                <van-empty v-else description="暂无数据" />
            </van-tab>
            <van-tab title="退房事项">
                <div class="form3">
                    <div class="card">
                        <div class="title">应收事项</div>
                        <table class="table">
                            <tr class="head">
                                <td>费用类型</td>
                                <td>金额</td>
                                <td>生成方式</td>
                                <td>
                                    <span>操作</span>
                                </td>
                            </tr>
                            <tr v-for="(item,index) in jzsReturnDetail.receivableOrderItems || []" :key="index">
                                <td>{{item.matterName}}</td>
                                <td>{{item.amount}}</td>
                                <td>{{item.readOnly?'系统':'手动'}}</td>
                                <td>
                                    <span style="color:#FD7E2D" @click="$dialog.alert({message:item.remark})">查看</span>
                                </td>
                            </tr>
                            <tr>
                                <td>应收合计</td>
                                <td>{{jzsReturnDetail.receivableOrderAmount}}元</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                    <div class="card">
                        <div class="title">应付事项</div>
                        <table class="table">
                            <tr class="head">
                                <td>费用类型</td>
                                <td>金额</td>
                                <td>生成方式</td>
                                <td>
                                    <span>操作</span>
                                </td>
                            </tr>
                            <tr v-for="(item,index) in jzsReturnDetail.payableOrderItems || []" :key="index">
                                <td>{{item.matterName}}</td>
                                <td>{{item.amount}}</td>
                                <td>{{item.readOnly?'系统':'手动'}}</td>
                                <td>
                                    <span style="color:#FD7E2D" @click="$dialog.alert({message:item.remark})">查看</span>
                                </td>
                            </tr>
                            <tr>
                                <td>应付合计</td>
                                <td>{{jzsReturnDetail.payableOrderAmount}}元</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                    <div class="card">
                        <div class="title" v-if="jzsReturnDetail.payableOrderAmount-jzsReturnDetail.receivableOrderAmount>0">应付：{{jzsReturnDetail.payableOrderAmount}} - {{jzsReturnDetail.receivableOrderAmount}} = {{accSub(jzsReturnDetail.payableOrderAmount,jzsReturnDetail.receivableOrderAmount)}}</div>
                        <div class="title" v-else>应收：{{jzsReturnDetail.receivableOrderAmount}} - {{jzsReturnDetail.payableOrderAmount}} = {{accSub(jzsReturnDetail.receivableOrderAmount,jzsReturnDetail.payableOrderAmount)}}</div>
                    </div>
                </div>
            </van-tab>
            <div v-if="jzsReturnDetail.returnOrderStatus == 1 || jzsReturnDetail.returnOrderStatus == 2 || jzsReturnDetail.returnOrderStatus == 3 || jzsReturnDetail.returnOrderStatus == 4" style="height:1.2rem;"></div>
        </van-tabs>
        <!-- 审批 -->
        <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked" v-if="type == 1">
            <van-step v-for="item in trackRecordList" :key="item.id">
                <!-- 开始 -->
                <div v-if="item.taskStartEndType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item.actorTime">发起时间：{{item.actorTime}}</p>
                    </div>
                </div>
                <!-- 审批 -->
                <div v-else-if="item.taskType == 1">
                    <div v-for="(item1,index1) in item.actors" :key="index1">
                        <h4>{{item1.actorName}}</h4>
                        <p v-if="item1.approvalStatus">审批结果：{{approvalStatusList[item1.approvalStatus-1]}}</p>
                        <p v-if="item1.remark">审批意见：{{item1.remark}}</p>
                        <p v-if="item1.approvalTime">处理时间：{{item1.approvalTime}}</p>
                        <p v-if="item1.createTime">到达时间：{{item1.createTime}}</p>
                    </div>
                </div>
                <!-- 抄送 -->
                <div v-else-if="item.taskType == 2">
                    <div>
                        <h4>
                            <span v-for="(item1,index1) in item.actors" :key="index1">
                                <span v-if="index1!=0">/</span>
                                {{item1.actorName}}
                            </span>
                        </h4>
                        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>
                    </div>
                </div>
                <!-- 结束 -->
                <div v-else>结束</div>
            </van-step>
        </van-steps>
        <van-form ref="form" label-width="110px" input-align="left" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5">
            <van-field label="审批意见" :border="false" />
            <van-field v-model="formData.remark" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入审批意见" show-word-limit :rules="[{ required: true, message: '请输入审批意见' }]" />
        </van-form>
        <div v-if="$route.query.type" style="height:1.2rem"></div>
        <div class="btn" v-if="$route.query.type">
            <van-button v-if="type == 0" @click="type = 1" type="primary">审批</van-button>
            <van-button v-if="type == 1" @click="type = 0" type="primary">详情</van-button>
            <van-button block type="primary" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(2)">驳回</van-button>
            <van-button block type="primary" v-if="$route.query.type == 1&&type == 1 && trackRecordList[0].status != 5" :loading="saveLoad" :disabled="saveLoad" @click="submit(1)">同意</van-button>
        </div>
        <!-- 资产详情 -->
        <van-dialog v-model="showAssets" title="资产详情" show-cancel-button :showConfirmButton="false" :showCancelButton="false" :closeOnClickOverlay="true" width="300">
            <van-cell title="名称" :value="asstesDetail.materialTypeName" />
            <van-cell title="品类" :value="asstesDetail.materialTypeParentName" />
            <van-cell title="规格" :value="asstesDetail.specification" />
            <van-cell title="品牌" :value="asstesDetail.brand" />
            <van-cell title="型号" :value="asstesDetail.model" />
        </van-dialog>
        <!-- 图片预览 -->
        <van-image-preview v-model="imgShow" :startPosition="imgIndex" :images="images"></van-image-preview>
        <!-- 加载 -->
        <div class="loading" v-if="loading"></div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestJzsReturnDetail,
    requestWorkflowDetail1,
    requestWorkflowSubmit,
      changeCompany, //钉钉消息进入详情页需切换公司 获取对应按钮权限
  requestButtomAuth,
} from "@/api";
import { mergeRowCol, accAdd, accSub, formatDate } from "@/utils/index";
export default {
    name: "jzsReturnDetail",
    data() {
        return {
            active: 0,
            activeNames: ["1", "2"],
            asstesDetail: {},
            showAssets: false,
            jzsReturnDetail: {
                contractOrderList: [],
                images: {},
                assets: [],
                nowAssets: [],
                historyAssets: [],
                houseBuilding: []
            },
            orderI: false,
            imgIndex: 0,
            images: [],
            imgShow: false,
            //审批
            type: 0, //切换0.详情/1.审批
            saveLoad: false,
            trackRecordList: [{ status: "" }],
            loading: true,
            formData: {
                remark: ""
            }
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList",
            "pQuitTypeList",
            "pReturntStatusList",
            "payTypeList",
            "approvalStatusList",
            "buildingTypeList"
        ])
    },
    created() {
        this.getDetail();
        if (this.$route.query.type) {
            //待办进入
            this.getWorkflow();
        }
    },
    mounted() {},
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestJzsReturnDetail(this.$route.query.id)
                .then(res => {
                    changeCompany({ companyId: res.data.companyId }).then(
                       (res) => {
                      this.$store.dispatch("resetAll", res.data);
                        requestButtomAuth().then((res) => {
                      this.$store.commit("SET_BUTTON", res.data || []);
                     });
                     }
                   );
                    let receivableOrderAmount = 0;
                    res.data.receivableOrderItems.forEach(d => {
                        receivableOrderAmount = accAdd(
                            receivableOrderAmount,
                            d.amount
                        );
                    });
                    let payableOrderAmount = 0;
                    res.data.payableOrderItems.forEach(d => {
                        payableOrderAmount = accAdd(
                            payableOrderAmount,
                            d.amount
                        );
                    });
                    res.data.receivableOrderAmount = receivableOrderAmount;
                    res.data.payableOrderAmount = payableOrderAmount;
                    res.data.houseBuilding =
                        res.data.historyHouseBuildingList ||
                        res.data.houseBuildingList;
                    res.data.houseBuilding.forEach(d => {
                        d.houseBuildingItems.forEach(e => {
                            const show = e.roomInfo.find(f => {
                                return (
                                    f.isSign &&
                                    res.data.contractId == f.communityContractId
                                );
                            });
                            d.show = d.show ? d.show : show;
                            e.show = show;
                        });
                    });
                    // res.data.nowAssets = this.assetsFilter(
                    //     res.data.assets,
                    //     "roomNo"
                    // );
                    this.jzsReturnDetail = res.data;
                    this.loading = false;
                    toast1.clear();
                })
                .catch(err => {
                    toast1.clear();
                });
        },
        assetsFilter(arr, key) {
            let keyArr = [];
            let newArr = [];
            arr.forEach(d => {
                if (keyArr.indexOf(d[key]) == -1) {
                    keyArr.push(d[key]);
                }
            });
            keyArr.forEach(d => {
                let obj = {
                    roomId: "",
                    roomNo: d,
                    materials: []
                };
                arr.forEach(e => {
                    if (d == e[key]) {
                        obj.roomId = e.roomId;
                        obj.materials.push(e);
                    }
                });
                newArr.push(obj);
            });
            return newArr;
        },
        //查流程
        getWorkflow() {
            //审批待办
            requestWorkflowDetail1(this.$route.query.agentId).then(res => {
                this.trackRecordList = res.data ? res.data : [];
                this.trackRecordList[0].status == 5
                    ? (this.type = 1)
                    : (this.type = 0);
                // this.loading = false;
            });
        },
        accSub(num1, num2) {
            return accSub(num1, num2);
        },
        //资产详情
        lookAssets(assets) {
            this.asstesDetail = assets;
            this.showAssets = true;
        },
        //审批提交
        submit(type) {
            let param = {
                agentId: this.$route.query.agentId,
                orderId: this.$route.query.orderId,
                approvalStatus: type,
                remark: this.formData.remark
            };
            if (type == 1) {
                //同意
                this.$dialog.confirm({
                    title: "提示",
                    message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    beforeClose: (action, done) => {
                        if (action === "confirm") {
                            this.saveLoad = true;
                            requestWorkflowSubmit(param)
                                .then(res => {
                                    this.$toast.success("审批成功");
                                    this.getWorkflow();
                                    this.saveLoad = false;
                                    done();
                                })
                                .catch(err => {
                                    this.saveLoad = false;
                                    done(false);
                                });
                        } else {
                            done();
                        }
                    }
                });
            } else {
                //驳回
                this.$refs["form"].validate().then(valid => {
                    this.$dialog.confirm({
                        title: "提示",
                        message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        beforeClose: (action, done) => {
                            if (action === "confirm") {
                                this.saveLoad = true;
                                requestWorkflowSubmit(param)
                                    .then(res => {
                                        this.$toast.success("审批成功");
                                        this.getWorkflow();
                                        this.saveLoad = false;
                                        done();
                                    })
                                    .catch(err => {
                                        this.saveLoad = false;
                                        done(false);
                                    });
                            } else {
                                done();
                            }
                        }
                    });
                });
            }
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#jzsReturnDetail {
    .colorC {
        color: $colorC;
    }
    .theme-color {
        color: $theme-color;
    }
    .titlee {
        padding: 0.2rem 0;
        background-color: #fff;
        font-size: 0.3rem;
    }
    .content {
        background-color: #fff;
        display: flex;
        // border-radius: 0.2rem;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        &.nowarp {
            flex-wrap: nowrap;
        }
        .inlineB {
            flex: 1;
            padding: 0.2rem 0;
            width: 33.3%;
            min-width: 33.3%;
            max-width: 33.3%;
            p.l {
                line-height: 0.7rem;
                height: 0.7rem;
            }
        }
    }
    .tabs {
        .title {
            text-align: left;
            padding: 0.3rem 0.2rem;
            font-weight: 600;
            font-size: 0.37rem;
        }
        /deep/.van-tabs__wrap {
            margin: 0.2rem 0 0;
        }
        /deep/.van-tabs__content {
            height: calc(100vh - 4.3rem);
            overflow: scroll;
        }
        .van-steps {
            text-align: left;
            padding-left: 2rem;
            /deep/.van-step__title {
                padding-left: 0.3rem;
                p {
                    padding-top: 0.2rem;
                }
            }
        }
        .assets {
            .title {
                background-color: #fff;
            }
            .assetsBody {
                display: flex;
                justify-content: flex-start;
                background-color: #fff;
                padding: 0.2rem 0;
                flex-wrap: wrap;
                > div {
                    width: 28%;
                    height: 0.8rem;
                    line-height: 0.8rem;
                    border: 1px solid $theme-color;
                    color: $theme-color;
                    text-align: center;
                    margin: 0 2.5% 0.1rem;
                }
            }
        }
        .orderBody {
            padding: 0 0.2rem;
            // border: 2px dashed #dadada;
            font-size: 0.3rem;
            margin: 0.2rem 0;
            border-radius: 0.2rem;
            background-color: #fff;
            &:first-child {
                margin-top: 0;
            }
            .orderBody-head {
                padding: 0.2rem;
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid $border-color;
                .line {
                    width: 1px;
                    height: 0.8rem;
                    transform: translateY(0.05rem);
                    background: #dadada;
                }
                .name {
                }
                .text {
                    font-weight: bold;
                    // color: $font-deep-gray;
                }
                p {
                    padding: 0.1rem 0;
                }
            }
            .orderBody-body {
                display: flex;
                padding: 0.3rem 0;
                border-bottom: 1px solid $border-color;
                .name {
                    flex: 1;
                    text-align: left;
                    .money {
                        color: $fail-color;
                    }
                }
                .success {
                    color: $success-color;
                }
                .fail {
                    color: $fail-color;
                }
                .pay {
                    color: #fff;
                    padding: 0.1rem 0.2rem;
                    background: #fd7e2d;
                    border-radius: 0.1rem;
                }
                .text {
                    span {
                        display: inline-block;
                        width: 0.5rem;
                    }
                    i {
                        font-size: 0.3rem;
                    }
                }
            }
            .border-b {
                border: none !important;
            }
            .details {
                color: $font-deep-gray;
                padding: 0.2rem 0;
                > div {
                    display: flex;
                    padding: 0.1rem;
                    .name {
                        flex: 1;
                        text-align: left;
                    }
                }
            }
            .blod {
                font-weight: bold;
            }
        }
        .imgBody {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            background-color: #fff;
            padding: 0.5rem 0.2rem 0;
            border-radius: 0.2rem;
            .imgCard {
                .text {
                    line-height: 0.8rem;
                }
            }
        }
        .imgBody1 {
            padding: 0 0.2rem;
        }
    }
    .btn {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        border-radius: 0.1rem;
        overflow: hidden;
        display: flex;
        /deep/.van-button {
            margin-left: -1px;
            border: none;
            border-radius: 0;
            flex: 1;
            padding: 0%;
            &:not(:last-child)::after {
                height: 50%;
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                border-right: 0.02667rem solid #ebedf0;
                z-index: 99;
            }
        }
    }
    .form3 {
        /deep/.van-tab {
            text-align: left;
            font-weight: 600;
            .van-tab__text {
                font-size: 0.4rem;
            }
        }
        /deep/.van-tabs__content {
            height: auto;
        }
        .card {
            margin: 0.2rem 0;
            border-radius: 0.2rem;
            overflow: hidden;
        }
        .title {
            font-size: 0.4rem;
            text-align: left;
            padding: 0 0.4rem;
            font-weight: 600;
            background-color: #fff;
            line-height: 1.1rem;
            color: #fd7e2d;
            position: relative;
            .icon {
                position: absolute;
                right: 0.4rem;
            }
        }
        /deep/.van-tabs {
            .van-tabs__wrap {
                font-size: 0.4rem;
                padding: 0 0.27rem;
                background-color: #fff;
                border-radius: 0.2rem 0.2rem 0 0;
            }
        }
        .table {
            tr {
                td {
                    text-align: center;
                    line-height: 0.7rem;
                }
            }
            .head {
                font-weight: 600;
            }
        }
    }
    .van-steps {
        text-align: left;
        padding-left: 2rem;
        /deep/.van-step__title {
            padding-left: 0.3rem;
            p {
                padding-top: 0.2rem;
            }
        }
    }
    .van-collapse {
        /deep/.van-cell__title {
            flex: 1;
        }
    }
    /deep/.van-collapse-item__content {
        padding-top: 0;
    }
}
</style>
